const frontendToBackendTypeMap = {
    'Students': 'Student',
    'Student': 'students',
    'Staff': 'Staff',
    'Modules': 'Module',
    'Module': 'modules',
    'Student/Module/Activity': 'StudentModuleActivity',
    'Activity/Staff': 'ActivityStaff',
    'Module/Staff': 'ModuleStaff'
};

const backendToFrontendTypeMap = Object.fromEntries(
    Object.entries(frontendToBackendTypeMap).map(([key, value]) => [value, key])
);

export const mapFrontendTypeToBackend = (frontendType) => {
    return frontendToBackendTypeMap[frontendType] || frontendType;
};

export const mapBackendTypeToFrontend = (backendType) => {
    return backendToFrontendTypeMap[backendType] || backendType;
};

